/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { OrganizationalUnitSelectComponent } from './organizational-unit-select.component';
import { IntersectionObserverModule } from 'ngx-intersection-observer';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'sesio-lib';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  declarations: [OrganizationalUnitSelectComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatInputModule,
    MatProgressBarModule,
    IntersectionObserverModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule.forChild(),
    PipesModule,
    NgPipesModule,
  ],
  exports: [OrganizationalUnitSelectComponent],
})
export class OrganizationalUnitSelectModule {}
